<template>
  <div id="payroll-detail">
    <div class="payroll-detail-list">
      <div class="payroll-detail-list-item">
        <div class="line">
          <div class="title">姓名:</div>
          <div class="value">
            <el-select
              v-model="value.employeeId"
              placeholder="请选择员工姓名"
              filterable
            >
              <el-option
                v-for="item in value.staffList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="payroll-detail-list-item">
        <div class="line">
          <div class="title">月份:</div>
          <div class="value">
            <el-date-picker
              v-model="value.date"
              type="month"
              placeholder="选择月"
              value-format="yyyy-MM"
              :clearable="false"
            >
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="payroll-detail-list-item">
        <div class="line">
          <div class="title">基本工资:</div>
          <div class="value">
            <el-input v-model="value.basicPay"> </el-input>
          </div>
        </div>
        <div class="line" style="align-items: start;">
          <div class="title">备注:</div>
          <div class="value">
            <el-input type="textarea" v-model="value.basicPayRemark"></el-input>
          </div>
        </div>
      </div>
      <div class="payroll-detail-list-item">
        <div class="line">
          <div class="title">岗位工资:</div>
          <div class="value">
            <el-input v-model="value.postWage"> </el-input>
          </div>
        </div>
        <div class="line" style="align-items: start;">
          <div class="title">备注:</div>

          <div class="value">
            <el-input type="textarea" v-model="value.postWageRemark"></el-input>
          </div>
        </div>
      </div>
      <div class="payroll-detail-list-item">
        <div class="line">
          <div class="title">绩效工资:</div>
          <div class="value">
            <el-input v-model="value.meritPay"> </el-input>
          </div>
        </div>
        <div class="line" style="align-items: start;">
          <div class="title">备注:</div>

          <div class="value">
            <el-input type="textarea" v-model="value.meritPayRemark"></el-input>
          </div>
        </div>
      </div>
      <div class="payroll-detail-list-item">
        <div class="line">
          <div class="title">绩效提成:</div>
          <div class="value">
            <el-input v-model="value.meritCommission"> </el-input>
          </div>
        </div>
        <div class="line" style="align-items: start;">
          <div class="title">备注:</div>

          <div class="value">
            <el-input
              type="textarea"
              v-model="value.meritCommissionRemark"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="payroll-detail-list-item">
        <div class="line">
          <div class="title">业务提成 (增减):</div>
          <div class="value">
            <el-input v-model="value.businessCommissionIncOrDec"> </el-input>
          </div>
        </div>
        <div class="line" style="align-items: start;">
          <div class="title">备注:</div>

          <div class="value">
            <el-input
              type="textarea"
              v-model="value.businessCommissionIncOrDecRemark"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="payroll-detail-list-item">
        <div class="line">
          <div class="title">奖金:</div>
          <div class="value">
            <el-input v-model="value.bonus"> </el-input>
          </div>
        </div>
        <div class="line" style="align-items: start;">
          <div class="title">备注:</div>

          <div class="value">
            <el-input type="textarea" v-model="value.bonusRemark"></el-input>
          </div>
        </div>
      </div>
      <div class="payroll-detail-list-item">
        <div class="line">
          <div class="title">津贴补助:</div>
          <div class="value">
            <el-input v-model="value.subsidy"> </el-input>
          </div>
        </div>
        <div class="line" style="align-items: start;">
          <div class="title">备注:</div>

          <div class="value">
            <el-input type="textarea" v-model="value.subsidyRemark"></el-input>
          </div>
        </div>
      </div>
      <div class="payroll-detail-list-item">
        <div class="line">
          <div class="title">考勤扣款:</div>
          <div class="value">
            <el-input v-model="value.attendanceDeduction"> </el-input>
          </div>
        </div>
        <div class="line" style="align-items: start;">
          <div class="title">备注:</div>

          <div class="value">
            <el-input
              type="textarea"
              v-model="value.attendanceDeductionRemark"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="payroll-detail-list-item">
        <div class="line">
          <div class="title">个税:</div>
          <div class="value">
            <el-input v-model="value.individualIncomeTax"> </el-input>
          </div>
        </div>
        <div class="line" style="align-items: start;">
          <div class="title">备注:</div>

          <div class="value">
            <el-input
              type="textarea"
              v-model="value.individualIncomeTaxRemark"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="payroll-detail-list-item">
        <div class="line">
          <div class="title">五险代扣合计:</div>
          <div class="value">
            <el-input v-model="value.socialSecurityWithholding"> </el-input>
          </div>
        </div>
        <div class="line" style="align-items: start;">
          <div class="title">备注:</div>

          <div class="value">
            <el-input
              type="textarea"
              v-model="value.socialSecurityWithholdingRemark"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="payroll-detail-list-item">
        <div class="line">
          <div class="title">累计工资收入备注:</div>
          <div class="value">
            <el-input
              type="textarea"
              v-model="value.wageIncomeRemark"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="payroll-detail-list-item">
        <div class="line">
          <div class="title">扣除总计备注:</div>
          <div class="value">
            <el-input
              type="textarea"
              v-model="value.deductTotalRemark"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="payroll-detail-list-item">
        <div class="line">
          <div class="title">实发工资备注:</div>
          <div class="value">
            <el-input
              type="textarea"
              v-model="value.netPayrollRemark"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="payroll-detail-list-item">
        <div class="line">
          <div class="title">扣分:</div>
          <div class="value">
            <el-input v-model="value.deductionOfPoints"> </el-input>
          </div>
        </div>
        <div class="line" style="align-items: start;">
          <div class="title">备注:</div>

          <div class="value">
            <el-input
              type="textarea"
              v-model="value.deductionOfPointsRemark"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="payroll-detail-list-item">
        <div class="line">
          <div class="title">所在公司:</div>
          <div class="value">
            <el-input type="textarea" v-model="value.company"></el-input>
          </div>
        </div>
      </div>
      <div class="payroll-detail-list-item">
        <div class="line">
          <div class="title">备注:</div>
          <div class="value">
            <el-input type="textarea" v-model="value.remark"></el-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    payrollDetail: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      value: [],
    };
  },
  methods: {
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
  },
  created() {
    this.value = this.payrollDetail;
    console.log("this.payrollDetail", this.payrollDetail);
  },
};
</script>

<style lang="less" scoped>
#payroll-detail {
  width: 100%;
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  /deep/ .el-input__inner {
    width: 175px;
  }
  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.2);
  }

  .payroll-detail-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .payroll-detail-list-item {
      font-size: 15px;
      width: 48%;
      margin-bottom: 20px;
      .line {
        width: 100%;
        display: flex;
        margin-bottom: 10px;
        align-items: center;
        .title {
          min-width: 120px;
          text-align: right;
          margin-right: 5px;
        }
        .value {
          width: 50%;
          /deep/ .el-input__inner {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
